// Suspend decorative animation when hidden; no tracking or external requests.
if (!window.rumiVisibilityReady && 'IntersectionObserver' in window) {
  window.rumiVisibilityReady = true;
  const seen = new WeakSet();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => entry.target.toggleAttribute('data-rumi-offscreen', !entry.isIntersecting));
  });
  const watch = root => root.querySelectorAll('.rumi-community-banner, .header-slogan, .brand-emblem').forEach(element => {
    if (!seen.has(element)) { seen.add(element); observer.observe(element); }
  });
  watch(document);
  document.addEventListener('shopify:section:load', event => watch(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.rumi-community-banner, .header-slogan, .brand-emblem').forEach(element => observer.unobserve(element));
  });
  const update = () => document.documentElement.toggleAttribute('data-rumi-page-hidden', document.hidden);
  document.addEventListener('visibilitychange', update);
  update();
}
